// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.absolute-row-YGtTmA{z-index:10;background:0 0;flex-direction:column;justify-content:center;align-items:center;row-gap:16px;width:100%;margin-bottom:12px;transition:height .1s ease-in-out;display:flex;position:absolute;bottom:100%}.bg-yV2ssa{background-color:rgba(var(--trebox-bg-3),var(--trebox-bg-3-alpha))!important}.bg-yV2ssa:hover{background-color:#e9ebf3!important}.bg-yV2ssa:active{background-color:#dce0ea!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"absolute-row": `absolute-row-YGtTmA`,
	"absoluteRow": `absolute-row-YGtTmA`,
	"bg": `bg-yV2ssa`
};
export default ___CSS_LOADER_EXPORT___;
